// src/pages/clientes/schemas/clienteSchema.ts
import { z } from 'zod';

export const clienteSchema = z.object({
  codigo: z.string().min(1, 'El código es requerido').max(20),
  nombre: z.string().min(1, 'El nombre es requerido').max(200),
  nombre_corto: z.string().max(50).optional().or(z.literal('')),
  modo_operacion: z.enum(['SIMPLE', 'ESTANDAR', 'CORPORATIVO']).default('SIMPLE'),
});

export type ClienteFormData = z.infer<typeof clienteSchema>;

export const empresaSchema = z.object({
  nombre: z.string().min(1, 'El nombre es requerido').max(200),
  codigo: z.string().max(50).optional().or(z.literal('')),
});

export type EmpresaFormData = z.infer<typeof empresaSchema>;

export const contactoSchema = z.object({
  nombre: z.string().min(1, 'El nombre es requerido').max(200),
  email: z.string().email('Email inválido').optional().or(z.literal('')),
  telefono: z.string().max(50).optional().or(z.literal('')),
  cargo: z.string().max(100).optional().or(z.literal('')),
  es_principal: z.boolean().default(false),
});

export type ContactoFormData = z.infer<typeof contactoSchema>;
